import {all} from 'redux-saga/effects';
import app from './app';
import auth from './auth';
import user from './user';

export default function *root() {
    yield all([
        app(),
        user(),
        auth(),
    ]);
}



// WEBPACK FOOTER //
// /src/redux/saga/index.js